import type {UserId} from '@netx/core-user/types';
import {CheckoutType} from './constants';
import {checkoutsRuleDefaults} from './defaults';
import {CheckoutsRule} from './types';

export type CheckoutRuleBaseParams<T extends CheckoutType> = {
	type: T;
} & ([T] extends [CheckoutType.USER_ID]
	? {
			userId: UserId;
	  }
	: {});

export type CheckoutAllRuleParams = CheckoutRuleBaseParams<CheckoutType.ALL>;
export type CheckoutByUserRuleParams =
	CheckoutRuleBaseParams<CheckoutType.USER_ID>;

type GetCheckoutsRuleParams = CheckoutAllRuleParams | CheckoutByUserRuleParams;

export function createCheckoutsRule(
	params: CheckoutAllRuleParams,
): CheckoutsRule<CheckoutType.ALL>;

export function createCheckoutsRule(
	params: CheckoutByUserRuleParams,
): CheckoutsRule<CheckoutType.USER_ID>;

export function createCheckoutsRule(params: GetCheckoutsRuleParams) {
	const {type} = params;
	return {
		...checkoutsRuleDefaults,
		elementSubType1: type,
		elementValue1: type === CheckoutType.USER_ID ? params.userId : 0,
	};
}

export default createCheckoutsRule;
